import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "accordion-table" }
const _hoisted_2 = { class: "column column--first" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = {
  key: 0,
  class: "column"
}
const _hoisted_5 = { class: "accordion-table-container" }
const _hoisted_6 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_7 = ["onMouseenter"]
const _hoisted_8 = { class: "column" }
const _hoisted_9 = {
  key: 0,
  class: "column"
}
const _hoisted_10 = { class: "column" }
const _hoisted_11 = {
  key: 0,
  class: "accordion-table-sub-container"
}
const _hoisted_12 = ["onMouseenter"]
const _hoisted_13 = {
  key: 0,
  class: "wrapper-box-circle"
}
const _hoisted_14 = { class: "column" }
const _hoisted_15 = {
  key: 0,
  class: "column"
}

import IconChevroneUpSmall from '@/design-system/assets/icons/IconChevroneUpSmall.vue'
import SvgDisplay from '@/design-system/atoms/SvgDisplay.vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'

export interface OVERVIEW_DATA {
  id: string
  value1: string
  value2: number
  value3?: string | number
  items: any[]
  visible?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionTable',
  props: {
    data: {},
    firstColumnWide: { type: Boolean },
    titles: {},
    clickable: { type: Boolean }
  },
  emits: ['toggleCategory'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5b8a933e": (gridStyle.value)
}))

const props = __props

const emits = __emit

const store = useStore()

const hoveredTitle = ref<string>('')
const lastMousePosition = ref([0, 0])
const showTooltip = ref(false)
const trackedMouseEvent = ref<Object>()
const windowWidth = ref<number>(window.innerWidth)
const mobileScreen = computed(() => {
  return store.state.mobileScreen
})
const gridStyle = computed(() => {
  if (mobileScreen.value && windowWidth.value > 658)
    return props.data.some((object) => object.value3) ? '70% 1fr 1fr 0.5fr' : '80% 1fr 0.5fr'
  return props.data.some((object) => object.value3) ? '40% 1fr 1fr 0.5fr' : '65% 1fr 0.5fr'
})

function handleSpaceKey(event: Event, objectId: string) {
  event.preventDefault() // Prevent space bar scrolling
  emits('toggleCategory', objectId)
}
function setWindowWidth() {
  windowWidth.value = window.innerWidth
}
function trackPointer(event, title: string) {
  hoveredTitle.value = title
  const rect = event.currentTarget.getBoundingClientRect()
  if (event) {
    if (
      lastMousePosition.value[0] === event.clientX &&
      lastMousePosition.value[1] === event.clientY
    )
      return
    lastMousePosition.value = [event.clientX, event.clientY]
    trackedMouseEvent.value = {
      x: rect.left + rect.width / 2,
      y: rect.bottom + rect.height / 2
    }
    const targetEl = event.target as HTMLElement
    if (targetEl.firstElementChild) {
      showTooltip.value =
        targetEl.firstElementChild.clientWidth < targetEl.firstElementChild.scrollWidth
    }
  }
}

onMounted(() => {
  window.addEventListener('resize', setWindowWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', setWindowWidth)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.data?.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["accordion-table-header row", { 'row--first-column-wide': _ctx.firstColumnWide }])
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.titles.title1), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.titles.title2), 1),
          (_ctx.titles.title3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.titles.title3), 1))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "column" }, null, -1))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (object) => {
        return (_openBlock(), _createElementBlock("div", {
          key: object.id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["row", { 'row--clickable': _ctx.clickable, 'row--first-column-wide': _ctx.firstColumnWide }]),
            role: _ctx.clickable ? 'button' : undefined,
            tabindex: _ctx.clickable ? 0 : -1,
            onClick: ($event: any) => (_ctx.clickable ? emits('toggleCategory', object.id) : ''),
            onKeydown: [
              _withKeys(($event: any) => (_ctx.clickable ? emits('toggleCategory', object.id) : ''), ["enter"]),
              _withKeys((event) => _ctx.clickable ? handleSpaceKey(event, object.id) : '', ["space"])
            ]
          }, [
            _createElementVNode("div", {
              class: "column column--first",
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = false)),
              onMouseenter: (e) => trackPointer(e, object.value1 ?? '')
            }, [
              _createElementVNode("p", null, _toDisplayString(object.value1), 1),
              _withDirectives(_createVNode(TooltipStandard, {
                arrowPosition: "top-center",
                class: "tooltip",
                pointerEvent: trackedMouseEvent.value,
                text: hoveredTitle.value
              }, null, 8, ["pointerEvent", "text"]), [
                [_vShow, showTooltip.value]
              ])
            ], 40, _hoisted_7),
            _createElementVNode("div", _hoisted_8, _toDisplayString(object.value2), 1),
            (object.value3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(object.value3), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.clickable)
                ? (_openBlock(), _createBlock(IconChevroneUpSmall, {
                    key: 0,
                    class: _normalizeClass(["arrow-button-icon", { 'arrow-button-icon--object-expanded': object.visible }])
                  }, null, 8, ["class"]))
                : _createCommentVNode("", true)
            ])
          ], 42, _hoisted_6),
          (object.visible === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(object.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: _normalizeClass(["row", { 'row--first-column-wide': _ctx.firstColumnWide }])
                  }, [
                    _createElementVNode("div", {
                      class: "column column--first",
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = false)),
                      onMouseenter: (e) => trackPointer(e, item.value1 ?? '')
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.value1), 1),
                      (item.color)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(SvgDisplay, {
                              src: 'Icon-Circle-Small',
                              style: _normalizeStyle(`color: ${item.color}`)
                            }, null, 8, ["style"])
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(TooltipStandard, {
                        arrowPosition: "top-center",
                        class: "tooltip",
                        pointerEvent: trackedMouseEvent.value,
                        text: hoveredTitle.value
                      }, null, 8, ["pointerEvent", "text"]), [
                        [_vShow, showTooltip.value]
                      ])
                    ], 40, _hoisted_12),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.value2), 1),
                    (item.value3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.value3), 1))
                      : _createCommentVNode("", true),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "column" }, null, -1))
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})